import { useQuery, useQueryClient } from "@tanstack/react-query";

import { userProfileApi } from "api";
import { ApiQueryOptions } from "hooks/api/queryHelper";
import { transformToUserProfileClass } from "models/UserProfile";

const QUERY_KEY = ["userProfile"];

const transformResponse = (data) => {
  return transformToUserProfileClass(data.userProfile);
};

const fetchMyProfile = async () => {
  const [error, response] = await userProfileApi.fetchMyProfile();

  if (error) {
    throw error;
  } else {
    return response;
  }
};

const useFetchMyProfile = (options: ApiQueryOptions = {}) => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => fetchMyProfile(),
    select: transformResponse,
    ...options,
  });
};

const getMyProfile = () => {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(QUERY_KEY);

  return data ? transformResponse(data) : undefined;
};

export default useFetchMyProfile;

export { getMyProfile };
